export default __webpack_public_path__ + "static/media/onePersonBundle.ad106b0a.png";